/**
 * Single-choice control. Native <select> styled per spec; a custom listbox
 * is only warranted when options need icons/descriptions (not built here).
 * Spec: assets/handoffs/design_system_export/specs/Select.json
 *
 * No `props` block in the spec (styling only) — `size` ('sm'|'lg') is
 * inferred from `trigger` (36px) vs `triggerLarge` (44px, "form-panel size").
 *
 * @param {'sm'|'lg'=sm} size
 * @param {boolean=false} disabled
 * @param {Array<{value:string,label:string}>} options
 */
import React, { forwardRef } from "react";
import classNames from "classnames";
import Icon from "../icons/Icon";
import styles from "./Select.module.scss";

const Select = forwardRef(
  ({ size = "sm", disabled = false, options = [], className, children, ...rest }, ref) => {
    return (
      <div className={classNames(styles.root, styles[`root--${size}`], className)}>
        <select ref={ref} className={styles.trigger} disabled={disabled} {...rest}>
          {children ||
            options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
        <Icon name="ChevronDown" size={18} className={styles.chevron} />
      </div>
    );
  }
);

Select.displayName = "Select";

export default Select;
